const preBuyUtils = new window.PreBuyUtils()

class ProductOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  connectedCallback () {
    this.setupListeners()

    this.checkForPreBuy()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        triggerEl.addEventListener('click', this.handleTrigger.bind(this))
      })
    }
  }

  handleTrigger = event => {
    const variantTitle = event?.target?.value

    const matchingOption = this?.externalEls?.option?.elements.find(
      el => el.value === variantTitle,
    )

    if (matchingOption) {
      matchingOption.click()
    }
  }

  async checkForPreBuy () {
    const triggers = this.els?.trigger?.elements || []

    for (const el of triggers) {
      const { variantId, productId } = el.dataset

      const legacyPreOrder = el.dataset.preorder === 'true'

      const preBuyData = await this.getPreBuyData(productId, variantId)

      if (
        !legacyPreOrder &&
        preBuyData &&
        preBuyData?.enabled &&
        preBuyData?.variantPool
      ) {
        this.updatePreBuyProperties(el, preBuyData.variantPool)
      }
    }
  }

  updatePreBuyProperties (el, data) {
    el.insertAdjacentHTML(
      'beforeend',
      `
        <span class="prd-Options_Notify fz-10_13">
          ${window.theme.strings.dispatchPrefix} ${data?.estDispatchDateFormatted}
        </span>
      `,
    )
  }

  async getPreBuyData (productId, currentVariantId) {
    const preBuyData = await preBuyUtils.getPreBuyData(
      productId,
      currentVariantId,
    )

    return preBuyData
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
